<script setup>
defineProps({
    text: String
});

defineEmits(['update:text']);
</script>

<template>
    <div class="relative w-full">
        <i class="text-lg text-blue fi fi-rr-search leading-none absolute top-1/2 -translate-y-1/2 left-2 z-10"></i>
        <input
            class="w-full py-3 px-2 pl-11 border-2 border-b-0 lg:border-2 text-blue border-gray-300 focus:border-blue hover:border-blue/70 bg-white lg:rounded-lg lg:shadow-lg appearance-none outline-none transition-all ease-in-out"
            type="text" :value="text" :placeholder="$t('plain_search_news')"
            @input="$emit('update:text', $event.target.value)" />
    </div>
</template>
